module.exports = __webpack_public_path__ + "img/maintenance.2ab0d119.png";